/** dapur copy. Keys are flat, dot-namespaced and stable; placeholders use {name}. */
export const enDapur = {
  'kds.nav.tickets': 'Tickets',
  'kds.nav.menu': 'Menu',
  'kds.page.subtitle': 'Tickets per station, oldest first.',
  // ---- Header -------------------------------------------------------------------------
  'kds.clock.label': 'Branch time · {zone}',
  'kds.fullscreen.enter': 'Enter full screen',
  'kds.fullscreen.exit': 'Exit full screen',
  'kds.settings.open': 'Kitchen display settings',
  'kds.settings.title': 'Kitchen display settings',
  'kds.settings.description': 'Saved on this device only.',
  'kds.settings.threshold.label': 'Overdue after (minutes)',
  'kds.settings.threshold.hint':
    'Whole minutes from {min} to {max}. "Due soon" shows from 75% of this time.',
  'kds.settings.threshold.invalid': 'Enter a whole number from {min} to {max}.',

  // ---- Board ----------------------------------------------------------------------------
  'kds.stations.label': 'Kitchen station',
  'kds.stations.all': 'All',
  'kds.stations.loadFailed': 'Stations could not be loaded — showing every station.',
  'kds.board.title': 'Active tickets',
  'kds.board.description': 'Oldest first. Overdue after {minutes} min.',
  'kds.board.count': 'In progress: {count}',
  'kds.board.empty':
    'No active tickets yet — tickets appear when a waiter or cashier sends an order to the kitchen.',
  'kds.board.emptyStation':
    'No active tickets for {station} — tickets appear when a waiter or cashier sends an order to the kitchen.',
  'kds.recent.title': 'Ready & recent',
  'kds.recent.description': 'Ready, served and cancelled tickets from the last 3 hours.',
  'kds.recent.empty': 'Nothing ready yet — tickets move here once they are marked ready.',
  'kds.recent.readyAt': 'Ready at {time}',
  'kds.recent.servedAt': 'Served at {time}',
  'kds.recent.sentAt': 'Sent at {time}',
  'kds.recent.prepTime': 'Prepared in {time}',

  // ---- Ticket card ----------------------------------------------------------------------
  'kds.ticket.order': 'Order {number}',
  'kds.ticket.number': 'Ticket {number}',
  'kds.ticket.submission': 'Round {number}',
  'kds.ticket.station': 'Station: {name}',
  'kds.ticket.elapsedLabel': 'Waiting',
  'kds.ticket.elapsedAria': 'Waiting {time} since sent',
  'kds.urgency.overdue': 'Overdue',
  'kds.urgency.soon': 'Due soon',
  'kds.item.quantity': '{count}×',
  'kds.item.seat': 'Seat {seat}',
  'kds.item.note': 'Note',
  'kds.item.cancelled': 'Cancelled',
  'kds.item.cancelReason': 'Reason: {reason}',
  'kds.action.acknowledge': 'Acknowledge',
  'kds.action.start': 'Start cooking',
  'kds.action.ready': 'Mark ready',
  'kds.action.saving': 'Saving…',
  'kds.toast.conflict':
    'Ticket {ticket} ({table}) was changed on another device. The latest version is now shown.',
} as const;
